import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var plus_circle_filled_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12 4c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm3.8 8.8h-3v3h-1.5v-3h-3v-1.5h3v-3h1.5v3h3v1.5Z" }) });
export {
  plus_circle_filled_default as default
};
//# sourceMappingURL=plus-circle-filled.js.map
